<div class="one gap-y-10" [formGroup]="SettingForm" fxLayout="column">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="default-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEFAULTEXPENSETYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEFAULTEXPENSETYPE),
      }"
    >
      <mat-label>Default Expense</mat-label>
      <mat-select
        name="DEFAULTEXPENSETYPE"
        formControlName="DEFAULTEXPENSETYPE"
        placeholder="Default Expense"
      >
        @for (val of getDropDownValue.DEFAULTEXPENSETYPE; track val) {
          <mat-option value="{{ val.VALUE }}">{{ val.VALUE }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="default-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEFAULTPAIDTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEFAULTPAIDTYPE),
      }"
    >
      <mat-label>Default Paid Type</mat-label>
      <mat-select
        name="DEFAULTPAIDTYPE"
        formControlName="DEFAULTPAIDTYPE"
        placeholder="Default Paid Type"
      >
        <mat-option value="Paid">Paid</mat-option>
        <mat-option value="UnPaid">UnPaid</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="default-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEFAULTINCOMETYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEFAULTINCOMETYPE),
      }"
    >
      <mat-label>Default Income Type</mat-label>
      <mat-select
        name="DEFAULTINCOMETYPE"
        formControlName="DEFAULTINCOMETYPE"
        placeholder="Default Income Type"
      >
        @for (val of getDropDownValue.DEFAULTINCOMETYPE; track val) {
          <mat-option value="{{ val.VALUE }}">{{ val.VALUE }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="default-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEFAULTMATTERCLASS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEFAULTMATTERCLASS),
      }"
    >
      <mat-label>Default Matter Class</mat-label>
      <mat-select
        name="DEFAULTMATTERCLASS"
        formControlName="DEFAULTMATTERCLASS"
        placeholder="Default Matter Class"
      >
        @for (val of getDropDownValue.DEFAULTMATTERCLASS; track val) {
          <mat-option value="{{ val.DESCRIPTION }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="default-input-4 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SHORTNAMESTRATEGY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SHORTNAMESTRATEGY),
      }"
    >
      <mat-label>Matter No. Strategy</mat-label>
      <mat-select
        name="SHORTNAMESTRATEGY"
        formControlName="SHORTNAMESTRATEGY"
        placeholder="Matter No. Strategy"
      >
        @for (val of getDropDownValue.SHORTNAMESTRATEGY; track val) {
          <mat-option value="{{ val.DESCRIPTION }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="default-input-4 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.REQUIRECOSTAGREEMENT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REQUIRECOSTAGREEMENT),
      }"
    >
      <mat-label>Cost Agreement</mat-label>
      <mat-select
        name="REQUIRECOSTAGREEMENT"
        formControlName="REQUIRECOSTAGREEMENT"
        placeholder="Cost Agreement"
      >
        <mat-option value="Not Required">Not Required</mat-option>
        <mat-option value="Recommended">Recommended</mat-option>
        <mat-option value="Required">Required</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="default-input-4 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.OFFICECHEQUEFORMAT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.OFFICECHEQUEFORMAT),
      }"
    >
      <mat-label>Office Cheque Format</mat-label>
      <mat-select
        name="OFFICECHEQUEFORMAT"
        formControlName="OFFICECHEQUEFORMAT"
        placeholder="Office Cheque Format"
      >
        @for (val of getDropDownValue.OFFICECHEQUEFORMAT; track val) {
          <mat-option value="{{ val.DESCRIPTION }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <!-- <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">



</div> -->
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    @if ('' | productType) {
      <mat-form-field
        appearance="outline"
        class="default-input-4 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.REQUIREMATTEROWNER),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REQUIREMATTEROWNER),
        }"
      >
        <mat-label>Matter Owner</mat-label>
        <mat-select
          name="REQUIREMATTEROWNER"
          formControlName="REQUIREMATTEROWNER"
          placeholder="Matter Owner"
        >
          <mat-option value="Not Required">Not Required</mat-option>
          <mat-option value="Recommended">Recommended</mat-option>
          <mat-option value="Required">Required</mat-option>
        </mat-select>
      </mat-form-field>
    }
    @if ('' | productType) {
      <mat-form-field
        appearance="outline"
        class="default-input-4 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.REQUIREFEEEARNER),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REQUIREFEEEARNER),
        }"
      >
        <mat-label>Matter Fee Earner</mat-label>
        <mat-select
          name="REQUIREFEEEARNER"
          formControlName="REQUIREFEEEARNER"
          placeholder="Matter Fee Earner"
        >
          <mat-option value="Not Required">Not Required</mat-option>
          <mat-option value="Recommended">Recommended</mat-option>
          <mat-option value="Required">Required</mat-option>
        </mat-select>
      </mat-form-field>
    }
    @if ('' | productType) {
      <mat-form-field
        appearance="outline"
        class="default-input-4 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.SUNDRYFEEEARNER),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SUNDRYFEEEARNER),
        }"
      >
        <mat-label>Sundry Fee Earner</mat-label>
        <mat-select
          name="SUNDRYFEEEARNER"
          formControlName="SUNDRYFEEEARNER"
          placeholder="Sundry Fee Earner"
        >
          @for (val of getDropDownValue.SUNDRYFEEEARNER; track val) {
            <mat-option value="{{ val.DESCRIPTION }}">
              {{ val.DESCRIPTION }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    @if ('' | productType) {
      <mat-form-field
        appearance="outline"
        class="default-input-4 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.REQUIREMATTERTYPE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REQUIREMATTERTYPE),
        }"
      >
        <mat-label>Matter Type</mat-label>
        <mat-select
          name="REQUIREMATTERTYPE"
          formControlName="REQUIREMATTERTYPE"
          placeholder="Matter Type"
        >
          <mat-option value="Not Required">Not Required</mat-option>
          <mat-option value="Recommended">Recommended</mat-option>
          <mat-option value="Required">Required</mat-option>
        </mat-select>
      </mat-form-field>
    }
    @if ('' | productType) {
      <mat-form-field
        appearance="outline"
        class="default-input-4 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.REQUIRECLIENTSOURCE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REQUIRECLIENTSOURCE),
        }"
      >
        <mat-label>Client Source</mat-label>
        <mat-select
          name="REQUIRECLIENTSOURCE"
          formControlName="REQUIRECLIENTSOURCE"
          placeholder="Client Source"
        >
          <mat-option value="Not Required">Not Required</mat-option>
          <mat-option value="Recommended">Recommended</mat-option>
          <mat-option value="Required">Required</mat-option>
        </mat-select>
      </mat-form-field>
    }
    @if ('' | productType) {
      <mat-form-field
        appearance="outline"
        class="default-input-4 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.REQUIREFIELDOFLAW),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REQUIREFIELDOFLAW),
        }"
      >
        <mat-label>Field Of Law</mat-label>
        <mat-select
          name="REQUIREFIELDOFLAW"
          formControlName="REQUIREFIELDOFLAW"
          placeholder="Field Of Law"
        >
          <mat-option value="Not Required">Not Required</mat-option>
          <mat-option value="Recommended">Recommended</mat-option>
          <mat-option value="Required">Required</mat-option>
        </mat-select>
      </mat-form-field>
    }
  </div>

  <!-- [ngClass]="{'has-error':errorWarningData.Error?.REQUIREMATTERTYPE,'has-warning':errorWarningData.Warning?.REQUIREMATTERTYPE}" -->
  @if (
    ('New Matter Sundry' | tierPermission: 'New Matter Sundry') &&
    ('New Matter Sundry' | tierPermission: 'New Matter Sundry').ALLOWED == 1
  ) {
    <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
      @if ('' | productType) {
        <mat-form-field appearance="outline" class="default-input-6 pr-1">
          <mat-label>Automatic New Matter Sundry</mat-label>
          <mat-select
            name="AUTOMATICNEWMATTERSUNDRY"
            formControlName="AUTOMATICNEWMATTERSUNDRY"
            placeholder="Automatic New Matter Sundry"
          >
            <mat-option value="">no sundry is used</mat-option>
            @for (val of activitiesArray; track val) {
              <mat-option value="{{ val.ACTIVITYID }} - {{ val.ACTIVITYGUID }}">
                {{ val.ACTIVITYID }} &nbsp;
                {{ val.DESCRIPTION }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  }

  <div fxLayout="row wrap" class="check" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox
      name="CHARGEDISBGSTONGSTFREEMATTERS"
      formControlName="CHARGEDISBGSTONGSTFREEMATTERS"
      class="check_1"
      name="KNOWNBYOTHERNAME"
    >
      On Charge GST on Disbursements when GST Free matter
    </mat-checkbox>
    &nbsp;&nbsp;&nbsp;
    @if ('' | productType) {
      <mat-form-field
        style="margin-top: 15px"
        appearance="outline"
        class="default-input-4 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.REQUIREEXPENSEPAYEE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REQUIREEXPENSEPAYEE),
        }"
      >
        <mat-label>Payee not required on Spend Money transactions</mat-label>
        <mat-select
          name="REQUIREEXPENSEPAYEE"
          formControlName="REQUIREEXPENSEPAYEE"
          placeholder="Payee not required on Spend Money transactions"
        >
          <mat-option value="Not Required">Not Required</mat-option>
          <mat-option value="Recommended">Recommended</mat-option>
          <mat-option value="Required">Required</mat-option>
        </mat-select>
      </mat-form-field>
    }
  </div>

  @if (
    ('Conflict Check' | tierPermission: 'Conflict Check') &&
    ('Conflict Check' | tierPermission: 'Conflict Check').ALLOWED == 1
  ) {
    <div fxLayout="row wrap" class="check" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-checkbox
        name="SHOWCONFLICTCHECKFORNEWMATTER"
        formControlName="SHOWCONFLICTCHECKFORNEWMATTER"
        class="check_1"
        name="KNOWNBYOTHERNAME"
      >
        Show Conflict Check when creating new matter
      </mat-checkbox>
      <!-- <mat-checkbox class="check_2" name="KNOWNBYOTHERNAME">Allow Mobile Access
  </mat-checkbox>
  <mat-checkbox class="check_3" name="KNOWNBYOTHERNAME">Don’t Notify About Cloud Sync
  </mat-checkbox> -->
    </div>
  }
  <div class="pt-4">
    <mat-dialog-actions class="popup_ftr justify-end!">
      <button
        id="callApiId"
        class="mainbtn_size"
        matButton="filled"
        [disabled]="isspiner"
        (click)="saveDefaults()"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
      <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
    </mat-dialog-actions>
  </div>
  <!-- <div fxLayout="row" class="check" fxLayoutAlign="start center" fxFlex="1 0 auto">

  <mat-checkbox name="ALLOWMOBILEACCESS" formControlName="ALLOWMOBILEACCESS" class="check_2" name="KNOWNBYOTHERNAME">Allow Mobile Access
  </mat-checkbox>

</div>
<div fxLayout="row" class="check" fxLayoutAlign="start center" fxFlex="1 0 auto">

  <mat-checkbox name="DONTALLOWTRUSTOVERDRAWS" formControlName="DONTALLOWTRUSTOVERDRAWS" class="check_2" name="KNOWNBYOTHERNAME">Don’t Notify About Cloud Sync
  </mat-checkbox>

</div>  -->
</div>
